const Config = {
  baseUrl: 'https://qa-secure1.mhelpdesk.com',
  apiUrl: 'https://qa-secure1.mhelpdesk.com/api/api/',
  identity: {
    url: 'https://qa-login.mhelpdesk.com',
    client_secret: 'test123',
    client_id: 'passwordless_ui',
  },
  googleMapKey: 'AIzaSyAsAabAn1M5xkm8SxZqES4XOulFIGjt9f8',
  launchDarklyClientId: '5d8cba91622e3407a785a76c',
  mapQuestAPI: 'https://www.mapquestapi.com/search/v3/prediction',
  mapQuestAPIKey: 's5dBmTfK0OiSbGfEL8wU9IzPfNgaPNAR',
  qbUrl: 'https://qa-qb.mhelpdesk.com/',
  qboUrl: 'https://qa-quickbooks.mhelpdesk.com/Default.aspx',
  fuseBill: {
    publicKey: '373a52ef-9268-4716-eff9-e939c9cf7513',
    transparentRedirectUrl:
      'https://stg-payments.subscriptionplatform.com/api/paymentsv2/',
  },
  authScriptUrl: 'https://jstest.authorize.net/v3/AcceptUI.js',
  wePayServerMode: 'stage',
  wePayUrl: 'https://stage.wepay.com/login',
  pdfUrl: '/pdf',
  recurTestInverval: true,
  flagProvider: 'launchDarkly',
  showOldEstimateInvoiceLink: true,
  envName: 'qa',
};

export default Config;



// WEBPACK FOOTER //
// ./src/config/config.QA.js